<template>
  <div class="common_tools">
    <!-- 给个div方便布局 -->
    <div class="setting_full">
      <div class="checkbox_container">
        <Checkbox :status="switchKeyFull" @select="setSwitchState" />
        <span>启动不再弹出</span>
      </div>
    </div>
    <ul class="tools_box">
      <!-- user avatar -->
      <li
        v-report:mainclick="{ area: 'account', pos: 0 }" title="用户" class="icon_item user_icon_box"
        @click="userLoginHandle">
        <span :class="`icon icon_user ${ userIconClass }`" />

        <DialogBox
          v-if="isShowTipAd && !isVipForever && tipAd"
          key="2" v-report:mainclick="{ area: 'activity', pos: 1 }"
          :canClose="true" color="blue" :class="['red_package_dialog']"
          @clickClose="closeDialogAd"
          @click.native="clickDialogAd">
          <p class="info">{{ tipAd }}</p>
        </DialogBox>

        <DialogBox v-if="isLoginedIn && logoutVisible" key="1" class="msg_dialog">
          <ul class="user_list">
            <li v-if="!isVip" class="item" @click.stop="buyMember">成为会员</li>
            <li class="item" @click.stop="loginOut">退出登录</li>
          </ul>
        </DialogBox>

        <DialogBox key="2" :color="isLoginedIn ? '' : 'blue'" :class="`user_member_dialog ${ logoutVisible && 'logout_visible' }`">
          <p v-if="!isLoginedIn" class="info">您还没登陆</p>
          <UserInfoBox v-else />
        </DialogBox>
      </li>
      <!-- 页面重载 -->
      <li
        v-report:mainclick="{ area: 'refresh', pos: '' }" title="页面重载" class="icon_item"
        @click="clickReload"><span class="icon icon_reload" /></li>
      <!-- 设置 -->
      <li
        title="设置" class="icon_item" :class="{ active: settingListVisible }"
        @mousedown="settingListVisible = true">
        <span class="icon icon_setting" />

        <ToolsSettingList v-show="settingListVisible" @selectIndex="settingListSelectIndex" />
      </li>
      <!-- 收起页面 -->
      <li
        v-report:mainclick="{ area: 'mini', pos: '' }" title="收起" class="icon_item"
        @click="clickSetMini"><span class="icon icon_shrink" /></li>
    </ul>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox/index.vue'

import ToolsSettingList from './ToolsSettingList.vue'
import DialogBox from './DialogBox.vue'
import UserInfoBox from './UserInfoBox.vue'

import {
  ClientOpenTabsByBuy, ClientSetOfficeAddIn, ClientGetOfficeSetting,
  ClientSetUserInfo, ClientSendMsgToTable
} from '@/api/clientApi.js'
import { reportLoginShow, openActivity } from '@/common/business.js'
import { parseURL } from '@/common/utils.js'
import { CacheSessionSetIsRefresh, CacheGetIsNotShowTipAd, CacheSetIsNotShowTipAd } from '@/common/cache.js'
import { Operatetype, operateMethods, winTypeMap, switchKey } from '@/common/const.js'
import { report } from '@/report/index.js'
import api from '@/api'

export default {
  name: 'Tools',

  components: { Checkbox, ToolsSettingList, DialogBox, UserInfoBox },

  data () {
    return {
      settingListVisible: false,
      logoutVisible: false,
      visibleSetting: false,
      switchKeyFull: false,
      isShowTipAd: true,
      tipAd: ''
    }
  },

  computed: {
    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    isVip () {
      return this.$store.getters.isVip
    },

    isVipForever () {
      return this.$store.getters.isVipForever
    },

    isDuBaVip () {
      return this.$store.state.isDubaVip
    },

    userInfo () {
      return this.$store.state.userInfo
    },

    isMiniDefault () {
      return this.$store.getters.isMiniDefault
    },

    userIconClass () {
      if (this.isLoginedIn) {
        return this.isVip ? 'vip' : 'login'
      }
      return ''
    },

    isChannelKeniuTools () {
      return this.$store.getters['channel/isChannelKeniuTools']
    },

    isChannelDg () {
      return this.$store.getters['channel/isChannelDg']
    }
  },

  created () {
    this.changeVisibleSetting()
    this.getSwitchState()
    this.initTipAd()
  },

  mounted () {
    document.addEventListener('click', this.settingHandle)
  },

  destroyed () {
    document.removeEventListener('click', this.settingHandle)
  },

  methods: {
    imgError () { // lazyLoad在当前环境存在bug
      const errorAvatar = require('@/assets/images/icon_basic_avatar.png')
      this.$refs.img.src = errorAvatar
    },

    changeVisibleSetting () {
      const urlObj = parseURL(location.href)
      if (urlObj.params?.[Operatetype] === operateMethods.visibleswitch) {
        this.visibleSetting = true
      }
    },

    clickReload () {
      CacheSessionSetIsRefresh()
      location.reload()
    },

    clickDialogAd () {
      this.tipAd = ''
      openActivity(this.$store, 'tips')
    },

    closeDialogAd () {
      this.tipAd = ''
    },

    settingHandle (e) {
      const className = e.target.className

      if (this.logoutVisible && !className.includes('icon_use')) {
        this.logoutVisible = false
      }

      if (this.settingListVisible && !className.includes('icon_setting')) {
        this.settingListVisible = false
      }
    },

    userLoginHandle () {
      this.tipAd = ''
      if (this.isLoginedIn) {
        this.logoutVisible = true
        return
      }
      reportLoginShow()
      this.$store.dispatch('showLoginByChannel')
    },

    settingListSelectIndex (index) {
      if (index === 1) {
        this.$store.commit('tipsDialog/vuexChangeSettingDialogVisible', true)
      }
    },

    clickSetMini () {
      this.$store.dispatch('vuexChangeWinType', winTypeMap.mini)
    },

    getSwitchState () {
      ClientGetOfficeSetting((res) => {
        this.switchKeyFull = res[switchKey.full] // 这里的状态与设置的状态不互通，得刷新，暂不打通
      })
    },

    setSwitchState (flag) {
      report('mainclick', { area: 'noshow', pos: flag ? '0' : '1' })
      ClientSetOfficeAddIn(switchKey.full, flag)

      flag && this.$toast({ desc: '重启office后生效' })
    },

    buyMember () {
      this.logoutVisible = false
      ClientOpenTabsByBuy({ paysource: 'vip' })
    },

    loginOut () {
      this.logoutVisible = false
      this.$store.commit('vuexSetUserInfo', {})
      ClientSetUserInfo({})
        .then(() => {
          ClientSendMsgToTable('matDetail', 'logined')
        })
    },

    async initTipAd () {
      // 一天只显示一次
      this.isShowTipAd = !CacheGetIsNotShowTipAd()
      if (!this.isShowTipAd) {
        return
      }
      const posCode = this.isDuBaVip ? 'officeside_top_pop_activity_vip' : 'officeside_top_pop_activity_user'
      const req = { data: { pos_code: posCode } }
      const res = await api.common.adConfig(req)
      const config = res.data.list[0]?.items[0]
      this.tipAd = config?.title

      // 有内容，显示后，今天不再显示
      if (this.tipAd) {
        CacheSetIsNotShowTipAd()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common_tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  background-color: #fff;
  border-bottom: 1px solid $border_color;

  .setting_full { margin-left: 16px; color: $font_color_4;
    .checkbox_container { display: flex; align-items: center; }
  }

  .tools_box { display: flex; align-items: center; height: 100%; margin-right: 12px;

    .icon_item {
      position: relative;
      width: 28px;
      height: 28px;
      cursor: pointer;
      border-radius: 4px;

      &:hover { background-color: #f3f3f6; }

      &.icon_item { margin-left: 16px; }
    }
    .icon { display: inline-block; width: 100%; height: 100%; background-repeat: no-repeat; background-position: center center; background-size: 28px 28px; }
    .icon_user {
      background-image: url(~@/assets/images/icon_tools_user.svg);

      &.login { background-image: url(~@/assets/images/icon_tools_user_login.svg); }
      &.vip { background-image: url(~@/assets/images/icon_tools_user_vip.svg); }
    }
    .icon_user:hover ~ .user_member_dialog { display: block; }
    .icon_reload { background-image: url(~@/assets/images/icon_tools_reload.svg); }
    .icon_setting { background-image: url(~@/assets/images/icon_tools_setting.svg); }
    .icon_shrink { background-image: url(~@/assets/images/icon_tools_shrink.svg); }

    .user_icon_box {
      .logout_visible { &.user_member_dialog { display: none !important; } }

      .msg_dialog {
        position: absolute;
        top: 38px;
        left: -18px;
        z-index: 1;

        .user_list {
          padding: 5px 0;
          font-size: 12px;
          font-weight: 400;
          line-height: 26px;
          text-align: center;

          .item { &:hover { color: #fff; background-color: $theme_color; } }
        }
      }

      .user_member_dialog {
        position: absolute;
        top: 38px;
        right: -13px;
        z-index: 3;
        display: none;

        .info { padding: 0 10px; font-size: 12px; font-weight: 400; line-height: 30px; color: #fff; text-align: center; white-space: nowrap; }
      }
      .red_package_dialog { position: absolute; top: 38px; right: -13px; z-index: 1;
        .info { padding: 0 10px; font-size: 12px; font-weight: 400; line-height: 30px; color: #fff; text-align: center; white-space: nowrap; }
      }
    }
  }
}
</style>
